import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import AdminCompanyDetails from '../../../pages/logged_in/Admin/AdminCompanyDetails'

const AdminCompanyDetailsModal = ({ id, setPlan }) => {
    return (
        <ModalWrapper
            modalType={'AdminCompanyDetails'}
            modalCardClasses="adminCompanyDetailPage-modal-container"
            customStyle={{
                maxHeight: 'calc(90vh)',
                maxWidth: '800px',
                width: '90vw',
                padding: '0',
                borderRadius: '16px',
                overflow: 'hidden'
            }}
        >
            <AdminCompanyDetails id={id} setPlan={setPlan} />
        </ModalWrapper>
    )
}

export default AdminCompanyDetailsModal